/*
 * The account pages' shared pieces, after the v3 mockup (section 6.10): `.form-card` (a card of at
 * most 600px with a header row, a body and a footer), `.ro` (read-only value), `.sec-row`,
 * `.notice`, `.toolbar`, `.dl` and `.danger-zone`.
 */
.card {
  max-inline-size: 600px;
  background: var(--surface-raised);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
}

.wide {
  max-inline-size: 720px;
}

.spaced {
  margin-block-end: var(--space-4);
}

.danger {
  border-color: color-mix(in srgb, var(--danger-text) 35%, var(--border));
}

.head {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  min-block-size: 48px;
  padding: 0 var(--space-4);
  border-block-end: 1px solid var(--border);
}

.title {
  flex: 1;
  margin: 0;
  font-size: var(--font-size-14, 14px);
  font-weight: var(--font-weight-semibold);
}

.dangerTitle {
  composes: title;
  color: var(--danger-text);
}

.body {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  padding: var(--space-4);
}

.foot {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  justify-content: flex-end;
  align-items: center;
  padding: var(--space-3) var(--space-4);
  border-block-start: 1px solid var(--border);
}

.footMeta {
  margin-inline-end: auto;
  color: var(--text-subtle);
  font-size: var(--font-size-12);
}

.text {
  margin: 0;
  color: var(--text-muted);
  font-size: var(--font-size-13);
}

.help {
  margin: 0;
  color: var(--text-subtle);
  font-size: var(--font-size-12);
}

.error {
  margin: 0;
  color: var(--danger-text);
  font-size: var(--font-size-12);
}

.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.label {
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-medium);
}

.readOnly {
  display: flex;
  align-items: center;
  min-block-size: var(--control-height, 32px);
  padding: 0 10px;
  border: 1px solid var(--border);
  border-radius: var(--radius-control);
  background: var(--surface-sunken);
  color: var(--text-muted);
  font-size: var(--font-size-13);
  overflow-wrap: anywhere;
}

.securityRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  padding: 10px 12px;
  border: 1px solid var(--border);
  border-radius: var(--radius-control);
  font-size: var(--font-size-13);
}

.grow {
  flex: 1;
}

.notice {
  display: flex;
  gap: var(--space-2);
  align-items: flex-start;
  margin: 0;
  padding: 10px 12px;
  border-radius: var(--radius-control);
  font-size: var(--font-size-13);
  background: var(--surface-sunken);
  color: var(--text);
}

.noticeDanger {
  composes: notice;
  background: var(--danger-surface);
}

.noticeInfo {
  composes: notice;
  background: var(--action-soft);
}

.noticeText {
  margin: 0;
}

.steps {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  margin: var(--space-2) 0 0;
  padding-inline-start: var(--space-4);
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  margin-block-end: var(--space-4);
}

.spacer {
  flex: 1;
}

.meta {
  color: var(--text-subtle);
  font-size: var(--font-size-12);
}

.details {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 8px 16px;
  margin: 0;
  font-size: var(--font-size-13);
}

.details dt {
  color: var(--text-subtle);
}

.details dd {
  margin: 0;
}

.link {
  color: inherit;
  text-decoration: underline;
}

.link:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}
